import styled from 'styled-components';

export const RealTimeWrapper = styled.dl`
  display: flex;
  width: 580px;
  margin: 0 auto;
  margin-top: 22px;
  padding-left: 19px;

  ${({ theme }) => theme.media.mobile} {
    width: 335px;
    margin-top: 18px;
  }

  & > dt {
    font-size: ${({ theme }) => theme.fontSize.B3};
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    color: ${({ theme }) => theme.colors.white100};
    height: 20px;
    line-height: 13px;

    & > button {
      width: 20px;
      height: 20px;
      background-color: rgba(244, 244, 244, 0.3);
      border-radius: 2px;
      display: inline-block;
      border: none;
      padding: 0;
      text-align: center;
      margin-left: 8px;
    }
  }

  & > dd > ul {
    display: flex;
    margin-left: 7px;

    & > li {
      width: 120px;
      line-height: 17px;

      & > a {
        color: ${({ theme }) => theme.colors.white100};
        text-align: center;
        width: 100px;
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 14px;
      }

      ${({ theme }) => theme.media.mobile} {
        display: none;
        &:nth-of-type(1),
        &:nth-of-type(2) {
          display: block;
        }
      }
    }

    & > li + li {
      position: relative;
      &::before {
        content: '';
        display: block;
        position: absolute;
        top: 4px;
        left: 0px;
        width: 1px;
        height: 12px;
        opacity: 0.2;
        background-color: ${({ theme }) => theme.colors.white100};
      }
    }
  }
`;
